import gql from 'graphql-tag';

export default gql`
  mutation updateRsvpCollegeFair($input: updateRsvpCollegeFairInput!) {
    updateRsvpCollegeFair(input: $input) {
      collegeFair {
        id
        notes
        attending
        version
        status
      }
    }
  }
`;
